/* @flow */
import { assign } from 'lodash';

import Store from 'lib/Store';
import { ActionTypes as UserActionTypes } from 'user/UserConstants';
import { ActionTypes } from 'auth/AuthConstants';

class FeatureStore extends Store {
  getInitialState() {
    return {
      features: {},
    };
  }

  handleDispatch(action: Object): void {
    switch (action.type) {
      case ActionTypes.AUTH_SUCCESS:
      case UserActionTypes.LOAD_USER: {
        const user = action.user;
        assign(this.state.features, user.getFeatures());
        this.emitChange();
        break;
      }
      default:
        break;
    }
  }

  hasFeature(feature) {
    return !!this.state.features[feature];
  }
}

export default new FeatureStore();



// WEBPACK FOOTER //
// ./src/stores/FeatureStore.js